"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxFeePerGas = exports.argsObjToArr = exports.argsArrToObj = exports.convertChainIdToViemChain = exports.convertInputSchemaToJsonString = void 0;
const core_1 = require("@axiom-crypto/core");
const viem_1 = require("viem");
const chains_1 = require("viem/chains");
const constants_1 = require("../constants");
function convertInputSchemaToJsonString(args) {
    const inputs = Object.keys(args).map((key) => {
        let argType = args[key];
        let postfix = "";
        if (argType.slice(-2) === "[]") {
            postfix = "[]";
            argType = argType.slice(0, -2);
        }
        if ((0, core_1.getByteLength)(argType) < 32) {
            return `"${key}": "CircuitValue${postfix}"`;
        }
        return `"${key}": "CircuitValue256${postfix}"`;
    });
    return `{${inputs.map((inputLine) => `\n  ${inputLine}`)}\n}`;
}
exports.convertInputSchemaToJsonString = convertInputSchemaToJsonString;
function convertChainIdToViemChain(chainId) {
    switch (chainId) {
        case "1":
            return chains_1.mainnet;
        case "11155111":
            return chains_1.sepolia;
        default:
            throw new Error(`Unsupported chainId ${chainId}`);
    }
}
exports.convertChainIdToViemChain = convertChainIdToViemChain;
function argsArrToObj(args) {
    return {
        sourceChainId: args[0],
        dataQueryHash: args[1],
        computeQuery: args[2],
        callback: args[3],
        feeData: args[4],
        userSalt: args[5],
        refundee: args[6],
        dataQuery: args[7],
    };
}
exports.argsArrToObj = argsArrToObj;
function argsObjToArr(args) {
    return [
        args.sourceChainId,
        args.dataQueryHash,
        args.computeQuery,
        args.callback,
        args.feeData,
        args.userSalt,
        args.refundee,
        args.dataQuery,
    ];
}
exports.argsObjToArr = argsObjToArr;
async function getMaxFeePerGas(axiom) {
    const providerFeeData = (await axiom.config.provider.getFeeData()).maxFeePerGas;
    const publicClient = (0, viem_1.createPublicClient)({
        chain: convertChainIdToViemChain(axiom.config.chainId.toString()),
        transport: (0, viem_1.http)(axiom.config.providerUri),
    });
    let contractMinMaxFeePerGas = await publicClient.readContract({
        address: axiom.getAxiomQueryAddress(),
        abi: axiom.getAxiomQueryAbi(),
        functionName: "minMaxFeePerGas",
        args: [],
    });
    if (contractMinMaxFeePerGas === 0n) {
        contractMinMaxFeePerGas = constants_1.ClientConstants.MIN_MAX_FEE_PER_GAS;
    }
    if (providerFeeData > contractMinMaxFeePerGas) {
        return providerFeeData.toString();
    }
    console.log(`Network gas price below threshold. Using contract-defined minimum maxFeePerGas of ${contractMinMaxFeePerGas.toString()}`);
    return contractMinMaxFeePerGas.toString();
}
exports.getMaxFeePerGas = getMaxFeePerGas;
//# sourceMappingURL=utils.js.map